export const IMPORT_TAX_RATES = 'IMPORT_TAX_RATES';
export const IMPORT_TAX_RATES_SUCCESS = 'IMPORT_TAX_RATES_SUCCESS';
export const IMPORT_TAX_RATES_FAILURE = 'IMPORT_TAX_RATES_FAILURE';

export const FETCH_INITIAL_DATA_FOR_TAX_RATE_MODAL = 'FETCH_INITIAL_DATA_FOR_TAX_RATE_MODAL';
export const FETCH_INITIAL_DATA_FOR_TAX_RATE_MODAL_SUCCESS = 'FETCH_INITIAL_DATA_FOR_TAX_RATE_MODAL_SUCCESS';
export const FETCH_INITIAL_DATA_FOR_TAX_RATE_MODAL_FAILURE = 'FETCH_INITIAL_DATA_FOR_TAX_RATE_MODAL_FAILURE';
